import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import apiUrl from '../../api-config';


function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://aiprompts.vercel.com/">
                Ai Prompts
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
const defaultTheme = createTheme();
const getRandomColor = () => {
    return '#' + Math.random().toString(16).substr(-8);
  };
function Prompts() {
    const [searchParams, setSearchParams] = useSearchParams();

   const catName= searchParams.get("category");

    let configPrompts = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${apiUrl}/prompts?category=${catName}`,
        headers: {}
    };
    const [prompts, setPrompts] = React.useState([]);
    React.useEffect(() => {
        axios.request(configPrompts)
            .then((response) => {
                setPrompts(response.data);
                console.log(prompts);
            })
            .catch((error) => {
                console.log(error);
            });
    },[])

    return (
        <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <AppBar position="relative">
                <Toolbar>
                    <AutoModeIcon sx={{ mr: 2 }} />
                    <Typography variant="h6" color="inherit" noWrap>
                        Ai Prompts
                    </Typography>
                </Toolbar>
            </AppBar>
            <main>
                {/* Hero unit */}
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        pt: 8,
                        pb: 6,
                    }}
                >
                    <Container maxWidth="sm">
                        <Typography
                            component="h1"
                            variant="h2"
                            align="center"
                            color="text.primary"
                            gutterBottom
                        >
                            Ai Prompts
                        </Typography>
                        <Typography variant="h5" align="center" color="text.secondary" paragraph>
                            Explore over 6000 prompts across 100 categories to fuel your creativity. Unlock inspiration for writing,
                            brainstorming, or any project. Your endless source of ideas awaits!
                        </Typography>
                        {/* <Stack
                            sx={{ pt: 4 }}
                            direction="row"
                            spacing={2}
                            justifyContent="center"
                        >
                            <Button variant="contained">Main call to action</Button>
                            <Button variant="outlined">Secondary action</Button>
                        </Stack> */}
                    </Container>
                </Box>
                <Container sx={{ py: 8 }} maxWidth="md">
                    {/* End hero unit */}
                    <Grid container spacing={4}>
                        {prompts.map((prompt) => (
                            <Grid item key={prompt.id} xs={12} sm={6} md={4}>
                                <Card
                                    sx={{ height: '100%', display: 'flex',
                                     flexDirection: 'column',
                                    backgroundColor:getRandomColor()
                                 }}
                                >
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Typography gutterBottom variant="h5" component="h2">
                                        {prompt.category}
                                        </Typography>
                                        <Typography>
                                        {prompt.title}
                                        </Typography>
                                    </CardContent>
                                    <CardActions sx={{justifyContent:"flex-end"}}>
                                    <Button variant="contained" >Copy</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </main>
            {/* Footer */}
            <Box sx={{ bgcolor: 'background.paper', p: 6 }} component="footer">
                {/* <Typography variant="h6" align="center" gutterBottom>
          Footer
        </Typography> */}
                <Typography
                    variant="subtitle1"
                    align="center"
                    color="text.secondary"
                    component="p"
                >
                    {/* Something here to give the footer a purpose! */}
                </Typography>
                <Copyright />
            </Box>
            {/* End footer */}
        </ThemeProvider>
    );
}

export default Prompts